var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c("div", { staticClass: "main-content hrRealGPReport" }, [
        _c(
          "div",
          {
            staticClass: "section form-column",
            staticStyle: { width: "1350px" }
          },
          [
            _c(
              "el-form",
              {
                staticStyle: { "margin-top": "5px" },
                attrs: {
                  inline: true,
                  "label-width": "60px",
                  "label-position": "center"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "100px", label: "Month From" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "120px" },
                        attrs: { no: "copyMonthFrom" },
                        model: {
                          value: _vm.copyMonthFrom,
                          callback: function($$v) {
                            _vm.copyMonthFrom = $$v
                          },
                          expression: "copyMonthFrom"
                        }
                      },
                      _vm._l(_vm.copyMonths, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.copyMonthLabelFun(item),
                            value: item
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "40px", label: "To" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "120px" },
                        attrs: { no: "copyMonthTo" },
                        model: {
                          value: _vm.copyMonthTo,
                          callback: function($$v) {
                            _vm.copyMonthTo = $$v
                          },
                          expression: "copyMonthTo"
                        }
                      },
                      _vm._l(_vm.copyMonths, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.copyMonthLabelFun(item),
                            value: item
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_BranchCMP") } },
                  [
                    _c("cargo-advance-select", {
                      staticStyle: { width: "120px" },
                      attrs: {
                        no: "branchId",
                        "select-type": _vm.selectTypeNames.basic_data_Office,
                        clearable: false,
                        filterable: "",
                        "default-value": _vm.branchId,
                        "tag-value": "officeId",
                        "tag-name": "code",
                        "filter-tag-names": [
                          "englishName",
                          "chineseName",
                          "code"
                        ],
                        cache: false,
                        "static-options": _vm.currentOfficeList,
                        placeholder: " "
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.currentOfficeIdChange(p.value)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticStyle: { "margin-bottom": "15px!important" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { no: "dataExport", type: "primary" },
                        on: { click: _vm.printHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DataExport")))]
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "13px",
                          color: "orange",
                          "margin-left": "25px"
                        }
                      },
                      [_vm._v(_vm._s(_vm.lastMonthlyDate))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "printed-callback": _vm.templateSelectorDialog.printedCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }